/**
 * TODO: We should follow W3C standards for Tabs when we update this component
 *       to actually behave as a Tab
 */
import classNames from 'classnames';
import useModifierActions, { UseModifierActionsProps } from './useModifierActions';

const Tabs = (props: UseModifierActionsProps) => {
  const {
    modifier: { options },
  } = props;

  const {
    getActiveModifierOption,
    selectModifierOption,
  } = useModifierActions(props);

  return (
    <ul className="pdp-options-ul pdp-options-ul--wrapped-no-gap">
      {options?.map((option) => {
        const { value, label } = option;
        const active = getActiveModifierOption(value);

        return (
          <li
            key={`tab-nav-${label}-${value}`}
            className={classNames(value, 'pdp-options-tab', {
              active,
            })}
          >
            <div
              role="button"
              onClick={() => selectModifierOption(option)}
            >
              <span className="title">{label}</span>
            </div>
          </li>
        );
      })}
    </ul>
  );
};

export default Tabs;
